import React, { forwardRef } from 'react'

export const CheckboxLabel = forwardRef((props, ref) => {
  return <label ref={ref} {...props} />
})
